// AUTO-GENERATED by scripts/write-firebase-config.js — do not edit or commit.
export const FB_CONFIG = {
    "apiKey": "AIzaSyCWnPLvU-D9Pb6TOoxxvYWafgVUHb_jB7E",
    "authDomain": "syntimacy-prod.firebaseapp.com",
    "projectId": "syntimacy-prod",
    "storageBucket": "syntimacy-prod.firebasestorage.app",
    "messagingSenderId": "1048776057863",
    "appId": "1:1048776057863:web:ab7c6cbab314363b9d36a2"
};
